import { Box, Card, Stack, Text } from 'shell/components';

const CardDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Card</Text>
            <Box sx={{ width: 250 }}>
                <Card onClick={console.log}>
                    <Stack spacing={2}>
                        <Text variant={'h6'}>Project</Text>
                        <Text variant={'p2'}>
                            Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across
                            all continents except Antarctica
                        </Text>
                    </Stack>
                </Card>
            </Box>
        </>
    );
};

export default CardDemo;
